import { Alert } from "@mui/material";
import ProductSplitUi from "../components/ProductSplitUi";

export const BatchSplitDialog = ({
  templates,
  setTemplates,
  handleBatchSplitUpdate,
  selectedIndex,
  setSelectedIndex,
  setEditedMap,
  setFocusedField,
  editedMap,
  focusedField,
  updateBatchSplit,
  handleAddBatch,
  handleDeleteBatch,
  handleDeleteBatchDialog,
  globalData,
}) => {
  return (
    <>
      <Alert
        elevation={0}
        severity="warning"
        sx={{
          p: "0px 10px",
          alignItems: "center",
          borderRadius: 0,
          boxShadow: "none",
        }}
      >
        One or more batches have exceeded their bowl capacity. Please adjust the
        product quantities if necessary.
      </Alert>

      <ProductSplitUi
        batchDetails={templates?.batchDetails}
        setTemplates={setTemplates}
        handleBatchSplitUpdate={handleBatchSplitUpdate}
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        setEditedMap={setEditedMap}
        setFocusedField={setFocusedField}
        editedMap={editedMap}
        focusedField={focusedField}
        updateBatchSplit={updateBatchSplit}
        handleAddBatch={handleAddBatch}
        handleDeleteBatch={handleDeleteBatch}
        handleDeleteBatchDialog={handleDeleteBatchDialog}
        templates={templates}
        globalData={globalData}
      />
    </>
  );
};
